import { stringify } from 'query-string';

import { getQueryParam } from '@cast/utils';

import { AUTH_PROVIDER_QUERY_KEY } from '@cast/constants';
import { getScreenHintParam } from 'utils/auth/getScreenHint';

export const getRedirectToScreenUrl = (returnTo: string): string => {
  const authProvider = getQueryParam(AUTH_PROVIDER_QUERY_KEY);
  const _returnTo = returnTo || window.location.href;
  let queryParams: Record<string, string> = {
    returnTo: new URL(_returnTo).toString(),
    screenHint: getScreenHintParam(),
  };

  if (authProvider && ['google-oauth2', 'github'].includes(authProvider)) {
    queryParams = {
      'auth-provider': authProvider,
    };
  }

  return `${window.location.origin}/api/v1/auth?${stringify(queryParams, {
    skipEmptyString: true,
  })}`;
};

export const redirectToScreen = (returnTo: string): void => {
  window.location.replace(getRedirectToScreenUrl(returnTo));
};
